module.exports = __webpack_public_path__ + "img/default_course_content.572e830b.png";